<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    @submit.prevent="reset"
    @keydown="form.onKeydown($event)"
  >
      <toolbar
        :title="title"
        :loading="form.busy"
        enctype="multipart/form-data"
        :buttons="buttons"
        @save="save"
        @cancel="cancel"
      />
      <v-layout
        :id="ref"
        class="wrap justify-space-around form-body"
      >
          <v-col
            cols="12"
          >
            <v-file-input
              v-model="file"
              accept=".p12"
              label="Seleccione para agregar un archivo .p12 "
              type="file"
              ref="file"
              id="file"
              :rules="[rules.required]"
              required
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
              <v-select
                v-model="form.tipo_certificado"
                :items="items"
                :rules="[rules.required]"
                label="Tipo de Certificado"
              />
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="form.password"
              type="password"
              :rules="[rules.required]"
              label="Contraseña"
              placeholder="Contraseña"
              required
            />
          </v-col>
      </v-layout>
  </v-form>
</template>

<script>
import Form from 'vform';
import Toolbar from '~/components/Toolbar';

export default {
  middleware: 'auth',
  components: {
    Toolbar,
  },
  props: {
    id: { default: '' },
    action: { default: '' },
    message: { default: '' },
  },
  data: () => ({
      form: new Form({
        password: '',
        tipo_aplicacion: 2,
        tipo_certificado: '',
        busy: false,
      }),
      items: [
        { value: '01', text: 'Firma' },
        { value: '02', text: 'Transmisión' },
      ],
      name: '',
      title: 'Carga de Certificado Facturación Electronica',
      dialog: false,
      file: '',
      valid: false,
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
      },
      buttons: [
        {
          id: 'save',
          icon: 'mdi-content-save',
          name: 'Guardar',
          event: 'save',
          color: 'success',
        },
        {
          id: 'cancel',
          icon: 'mdi-close',
          name: 'Volver',
          event: 'cancel',
        },
      ],
      apiURL: '/api/enterprises',
      apiURLCertificate: 'certificate/store',
      method: 'POST',
  }),
  computed: {
    ref() { return this.form.id; },
  },
  methods: {
      validate() {
        if (this.$refs.form.validate()) {
          this.form.busy = true;
          this.store();
        }
      },
      show() {
        this.$router.push({ name: 'enterprise.viewFEL' });
      },
      store() {
        const formData = new FormData();

        formData.append('file', this.file);
        formData.append('password', this.form.password);
        formData.append('tipo_aplicacion', this.form.tipo_aplicacion);
        formData.append('tipo_certificado', this.form.tipo_certificado);

        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };

        const URL = `${this.apiURL}/${this.id}/${this.apiURLCertificate}/${this.form.tipo_aplicacion}`;
        window.axios.post(URL, formData, config)
        .then(() => {
          this.form.busy = false;
        }).catch(() => {
          this.form.busy = false;
        });
      },
      save() {
        this.validate(); // someValue
      },
      cancel() {
        this.$router.go(-1); // someValue
      },
    },
};
</script>
